var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimerGrp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138",
    transform: "translate(-399.91 -104.91)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(417.91 104.91) rotate(90)",
    fill: "#1383d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_367364_2_",
    "data-name": "367364 (2)",
    d: "M4.192,3.347,7.361.176a.6.6,0,0,1,.846,0,.6.6,0,0,1,0,.848L4.616,4.617a.6.6,0,0,1-.826.017L.175,1.027A.6.6,0,0,1,1.021.178Z",
    transform: "translate(405.043 111.977)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerGrp);
export default __webpack_public_path__ + "static/media/timer-grp.323681a27a2ec5e787230bd22943d9f7.svg";
export { ForwardRef as ReactComponent };